import { useEffect, useState } from "react";

/** true se la finestra è abbastanza larga per tabelle e layout a due colonne. */
export function useWide(min = 900): boolean {
  const query = `(min-width: ${min}px)`;
  const [wide, setWide] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const m = window.matchMedia(query);
    const on = () => setWide(m.matches);
    m.addEventListener("change", on);
    return () => m.removeEventListener("change", on);
  }, [query]);
  return wide;
}
